import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import FiltrosEvolucion from '../../components/fichaVerraco/FiltrosEvolucion'
import {abrirModalVacioEvolucion, seleccionarTodosEvolucion, deSeleccionarTodosEvolucion, deleteSeleccionEvolucion, abrirModalEvolucion} from '../../actions/fichaVerraco/fichaVerraco'

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    fichaVerraco: state.fichaVerraco,
    formSimpleTable: state.form.simpleTable
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      abrirModalVacioEvolucion,
      seleccionarTodosEvolucion,
      deSeleccionarTodosEvolucion,
      deleteSeleccionEvolucion,
      abrirModalEvolucion
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FiltrosEvolucion))